exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "social-security-card{display:block;background-color:#fff;margin-top:10px}social-security-card p{margin:0}social-security-card hr{margin:0;height:11px;background-color:#04408f;border-bottom:1px solid #dddfe2;border-top:1px solid #dddfe2}social-security-card span{display:block;white-space:nowrap;color:#04408f;font-family:Stag Sans;line-height:2.5;font-size:15px}social-security-card .first-row{border-bottom:1px solid #aeaeae;border-left:1px solid #dddfe2;border-right:1px solid #eaebed;padding:12px}social-security-card .second-row{padding:10px;border-left:1px solid #dddfe2;border-bottom:1px solid #dddfe2;border-right:1px solid #eaebed}social-security-card .second-row .middle{border-left:1px solid #aeaeae;border-right:1px solid #aeaeae}@media(max-width:944px){social-security-card .second-row .middle{border-left:0;border-right:0}}social-security-card .row{margin-left:0;margin-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/social-security.module/components/socialSecurityCard/socialSecurityCard.scss
// module id = 2298
// module chunks = 0